<template>
  <div>
    <h6>Poll Options</h6>
    <div class="input-group mb-3" v-for="(option, index) in options" :key="index">
      <input type="text" class="form-control" v-model="options[index]" :placeholder="option" @input="update">
      <div class="input-group-append">
        <button @click="removeOption(index)" class="btn btn-sm btn-outline-danger">X</button>
      </div>
    </div>
    <button @click="addOption" v-if="options.length < 10" class="btn btn-outline-success mb-3">+</button>
  </div>
</template>


<script>
export default {
  name: 'Options',
  props: {
    options: Array,
  },
  methods:{
    addOption: function(){
      this.options.push("")
    },
    removeOption: function(index){
      if(this.options.length > 2){
        this.options.splice(index,1);
      }
      else{
        this.$dialog.alert("Question should have atleast 2 options to select.")
      }

    },
    update: function(){
      this.$emit('updateOptions', this.options);
    }
  },
}
</script>
